import React, { FunctionComponent, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import icono_ubicacion from '../../../assets/img/ui_icons/icono_ubicacion.svg';
import icono_mail from '../../../assets/img/ui_icons/icono_mail.svg';
import iconos_familia from '../../../assets/img/LogosFamilia_pie.png';
import twitterblue from '../../../assets/img/twittergrey.png';
import linkedinblue from '../../../assets/img/linkedingrey.png';
import yticon from '../../../assets/img/icon-yt.png';
import redicon from '../../../assets/img/icon-redd.png';
import fbicon from '../../../assets/img/icono_fb.png';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';

const FooterMenu: FunctionComponent = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const validateNewsLetter = (email: string) => {
    const emailFormat = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    setValidEmail(email.match(emailFormat) !== null);
  };

  const processNewsLetterSubscription = async () => {
    setRegistering(true);
    try {
      await ObexRequestHandler.post(`/salesforce/register_neswletter?email=${newsletterEmail}`, {});
      setNewsletterEmail('');
      setValidEmail(false);
      setShowModal(true);
    } catch {
      setValidEmail(true);
    } finally {
      setRegistering(false);
    }
  };

  return (
    <footer className="fl-footer">
      <div className="fl-footer-row d-flex">
        <p className="fl-footer-logos">
          <img src={iconos_familia} alt="Logo of AVAP Framework with the icons of the main products and services" />
        </p>
        <div className="newsletter-container">
          <input
            id="newsletter-mail"
            type="email"
            placeholder="Enter your email"
            value={newsletterEmail}
            onChange={(e) => {
              setNewsletterEmail(e.target.value);
              validateNewsLetter(e.target.value);
            }}
          />
          <button
            onClick={processNewsLetterSubscription}
            disabled={!validEmail || registering}
            className='btn-brick-subscribe'
            aria-label="Button labeled 'Subscribe to Newsletter' to join AVAPs newsletter database"
          >
            {registering ? <Spinner animation="border" size="sm" /> : 'Subscribe to Newsletter'}
          </button>
        </div>
      </div>

      <div className="fl-footer-row grid">
        <div>
          <h4>Products</h4>
          <ul>
            <li><a href="/avap">AVAP (Advanced Virtual API Programming)</a></li>
            <li><a href="/devstudio">AVAP Dev Studio</a></li>
            <li><a href="/avap-zero">AVAP Zero</a></li>
            <li><a href="/vsc-extensions">AVAP Dev Studio API Extensions for MVSC</a></li>
            <li><a href="/gateway">AVAP Gateway Advanced</a></li>
            <li><a href="/avs">AVAP Virtual Server</a></li>
            <li><a href="/interpreter">AVAP Interpreter & Language Server</a></li>
            <li><a href="/commander">AVAP Commander</a></li>
            <li><a href="/meshmanager">AVAP Mesh Manager</a></li>
            <li><a href="/source-control">AVAP API Source Control</a></li>
            <li><a href="/release-manager">AVAP API Release Manager</a></li>
            <li><a href="/api-publisher">AVAP API Publisher</a></li>
            <li><a href="/avap-connectors">AVAP Connectors</a></li>
            <li><a href="/avap-vision">AVAP Vision</a></li>
          </ul>
        </div>

        <div>
          <h4>Open Source</h4>
          <ul>
            <li><a href="/platon">The PLATON Foundation</a></li>
          </ul>
          <h4 className="mt-40">Developer Support</h4>
          <ul>
            <li><a href="/default" target="_blank" rel="noopener noreferrer">AVAP Developer Portal</a></li>
            <li><a href="https://speed-computing-1656.my.site.com/communities/s/" target="_blank" rel="noopener noreferrer">AVAP Communities</a></li>
          </ul>
          <h4 className="mt-40">Platform Services Management</h4>
          <ul>
            <li><a href="/cli">AVAP CLI</a></li>
            <li><a href="/shell">AVAP Shell</a></li>
          </ul>
          <h4 className="mt-40">Newest Features</h4>
          <ul>
            <li><a href="/roadmap">Product Roadmap</a></li>
            <li><a href="/downloads">Download Center</a></li>
          </ul>
          <h4 className="mt-40"></h4>
          <ul>
            <li><a href="/cloud">AVAP Cloud</a></li>
            <li><a href="/brunix">Brunix AI</a></li>
          </ul>
        </div>

        <div>
          <h4>Knowledge Center</h4>
          <ul>
            <li><a href="https://speed-computing-1656.my.site.com/alexandria/s/?language=en_US" target="_blank" rel="noopener noreferrer">AVAP Alexandria</a></li>
            <li><a href="https://speed-computing-1656.my.site.com/blog/s/" target="_blank" rel="noopener noreferrer">AVAP Blog</a></li>
          </ul>
          <h4 className="mt-40">Education</h4>
          <ul>
            <li><a href="/collaborative">AVAP Collaborative Network</a></li>
          </ul>
          <h4 className="mt-40"></h4>
          <ul>
            <li><a href="/avap-marketplace">AVAP Marketplace</a></li>
          </ul>
        </div>

        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="/about">About us</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/pricing">Pricing</a></li>
          </ul>
          <h4 className="mt-40">Partners</h4>
          <ul>
            <li><a href="/connect">AVAP Connect</a></li>
          </ul>
        </div>

        <div>
          <h4>Legal</h4>
          <ul>
            <li><a href="https://speed-computing-1656.my.site.com/alexandria/s/news/avap-collaborative-network-terms-conditions-MCXYCPQ5L53JDSFN4HXYI66J2764?language=en_US" target="_blank">T&C AVAP Collaborative Network</a></li>
            <li><a href="https://101obex.my.site.com/alexandria/s/news/avap-cloud-professional-business-terms-conditions-MCOYQYTA5VQNDZDAS5UGXSU3GEV4?language=en_US" target="_blank">T&C AVAP Cloud</a></li>
            <li><a href="https://speed-computing-1656.my.site.com/alexandria/s/news/privacy-policy-MCSYZARSDENBDAVITQIIO6OWFYLI?language=en_US" target="_blank">Privacy Policy</a></li>
          </ul>
          <h4 className="mt-40">Getting Started</h4>
          <ul>
            <li><a href="https://avapid.com/" target="_blank">Create your AVAP ID</a></li>
            <li><a href="https://avapcloud.com/business_en" target="_blank">Start for Free AVAP Cloud</a></li>
            <li><a href="https://developer.avapframework.com" target="_blank">Visit our Developer Portal</a></li>
          </ul>
        </div>
      </div>

      <div className="fl-footer-row flex fl-border-bottom">
        <div>
          <p>Corporate head office</p>
          <p>1010BEX, CORP 440 N Wolfe RD Sunnyvale 94085, CA</p>
        </div>
        <div>
          <p>
            <img src={icono_mail} alt="Correo Electrónico" style={{ marginRight: '5px' }} />
            sales@1010bex.com
          </p>
          <p className="fl-footer-socials">
            <a href="https://www.linkedin.com/company/avap-framework" target="_blank" rel="noopener noreferrer">
              <img src={linkedinblue} alt="LinkedIn" width="16px" height="16px" />
            </a>
            <a href="https://www.youtube.com/@AVAPFramework" target="_blank" rel="noopener noreferrer">
              <img src={yticon} alt="YouTube" width="16px" height="16px" />
            </a>
            <a href="https://x.com/AvapFramework" target="_blank" rel="noopener noreferrer">
              <img src={twitterblue} alt="X (Twitter)" width="16px" height="16px" />
            </a>
            <a href="https://www.facebook.com/AVAPFramework" target="_blank" rel="noopener noreferrer">
              <img src={fbicon} alt="Facebook" width="16px" height="16px" />
            </a>
          </p>
        </div>
      </div>

      <div className="fl-footer-row center fl-border-top">
        <p>© 2024 1010BEX, CORP. All rights reserved</p>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Body className="text-center">
          <h1>Congratulations</h1>
          <p>You have been registered in the AVAP Newsletter</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn custom-button textBold" onClick={handleClose}>
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </footer>
  );
};

export default FooterMenu;